import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CheckNotaryFilters  {
    _originalTypeClassName = "zERP.BO.CheckNotaryFilters";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CheckNotaryFilters.translate = translateService;
}
this.IncludeIncome = false;
this.IncludeExpense = false;
this.IssueDateStart = null;
this.IssueDateEnd = null;
this.CheckNotaryFiltersKey = null;
this._key = this.CheckNotaryFiltersKey = 0; 
}

static translate: TranslateService;
_key: any;
IncludeIncome:any;
IncludeExpense:any;
IssueDateStart:any;
IssueDateEnd:any;
Currency:any;
private _CheckNotaryFiltersKey:any;
get CheckNotaryFiltersKey(): any {
    return this._CheckNotaryFiltersKey;
  }
set CheckNotaryFiltersKey(value: any) {
    this._CheckNotaryFiltersKey = value;
    this._key = value;
  }
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CheckNotaryFiltersKey == null || $this.CheckNotaryFiltersKey == 0;
            }


}